import classnames from "classnames";
import parse, { domToReact } from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";

// Components
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import ContactDetailsBox from "../contact-details-box/contactDetailsBox";

// Utils
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";

// Styles
import styles from "./contact-us-manufacturer-solution.module.scss";

const numberClicked = number => {
  dispatchNewEvent("dataStateChange", {
    action: "contactUsDecisionSolution",
    type: window.jlData.page.decisionTree.refinement,
    solutionType: `manufacturer:${number.replace(/ /g, "")}`,
  });
};

function ContactUsManufacturerSolution({
  solution: { id, title, fields, hierarchyPosition },
  className,
  contactMethods,
}) {
  const locationOnPage = hierarchyPosition.join(" | ");
  return (
    <article className={classnames(styles.manufacturerSolution, className)} data-solution-id={id}>
      <h2 className={styles.manufacturerSolution__top}>Did you know...</h2>
      <div className={styles.manufacturerSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        {parse(fields.find(({ name }) => name === "content").content, {
          replace: ({ type, name: tagName, attribs: { ...nonStyleAttribs } = {}, children }) =>
            type === "tag" && nonStyleAttribs && React.createElement(tagName, nonStyleAttribs, domToReact(children)),
        })}
        <div className={styles["manufacturerSolution__manufacturer-details"]}>
          <h2>Contact {fields.find(({ name }) => name === "manufacturer").content} Technical Support</h2>
          <p>Please have the product with you when you call.</p>
          <div className={styles["manufacturerSolution__number-box"]}>
            <SecondaryButton
              tag="a"
              href={`tel:${fields.find(({ name }) => name === "manufacturerPhone").content.replace(/ /g, "")}`}
              onClick={() => numberClicked(id, fields.find(({ name }) => name === "manufacturerPhone").content)}
              className={styles["manufacturerSolution__number-button"]}
            >
              {fields.find(({ name }) => name === "manufacturerPhone").content}
            </SecondaryButton>
          </div>
        </div>
        <div className={styles.manufacturerSolution__separator}>
          <span>OR</span>
        </div>
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat"].includes(name))}
          title="Contact John Lewis & Partners Customer Service"
          className={styles["manufacturerSolution__contact-details-manufacturer"]}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
          buttonType="tertiary"
        />
      </div>
    </article>
  );
}

ContactUsManufacturerSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    emailUs: PropTypes.arrayOf(PropTypes.string),
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
  }),
};

ContactUsManufacturerSolution.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsManufacturerSolution;
